import { FC } from 'react';
import PageScaffold from '../components/PageScaffold';

const Reports: FC = () => {
  return (
    <PageScaffold
      title="Reports"
      subtitle="Build financial, operational, and merchandising reports."
    >
      Report builders and exports will be available in this area.
    </PageScaffold>
  );
};

export default Reports;
